export default function useDeliveryPromise(input: any[]) {
  const { $t } = useI18n()

  const weeks = (days: number) => {
    return Math.ceil(days / 7)
  }

  const calculate = computed<Set<number>>(() => {
    return new Set<number>(input.filter(item => parseInt(item) > 0).map((item: number | string) => weeks(parseInt(item as string))))
  })

  const firstAvailable = computed(() =>
    calculate.value.values().next().value,
  )

  const label = computed(() => {
    if (!calculate.value.size || calculate.value.has(0)) {
      return $t('Delivery time unknown')
    }
    if (calculate.value.size === 1) {
      if (calculate.value.has(1)) {
        return $t('Direct available')
      }
      else {
        return $t('Delivery within {deliveryTime} weeks', { deliveryTime: calculate.value.values().next().value })
      }
    }
    return $t('Order with multiple delivery dates? No worries, we\'ll deliver the products as soon as they\'re available. There\'s no extra shipping cost for half-price orders.')
  })

  return {
    calculate,
    label,
    firstAvailable,
  }
}
